import PropTypes from "prop-types";

// material-ui
import { styled, useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  // createTheme,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";

// project imports
import MainCard from "../cards/MainCard";
import SkeletonTotalCurrentPayOutDarkCard from "../cards/skeleton/SkeletonTotalCurrentPayOutDarkCard";

// assets
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import { colors } from "../../utility/types/constant";

declare module "@mui/material/styles" {
  interface PaletteColor {
    800?: string;
  }
  interface SimplePaletteColorOptions {
    800?: string;
  }

  interface TypographyVariants {
    commonAvatar: React.CSSProperties;
    smallAvatar: React.CSSProperties;
    mediumAvatar: React.CSSProperties;
    largeAvatar: React.CSSProperties;
  }

  // Allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    commonAvatar?: React.CSSProperties;
    smallAvatar?: React.CSSProperties;
    mediumAvatar: React.CSSProperties;

    largeAvatar?: React.CSSProperties;
  }
}

// const theme = createTheme({
//   palette: {
//     secondary: {
//       main: "#f50057",
//       dark: "#c51162",
//       800: "#9c0045", // Your custom numeric shade
//     },
//   },
// });

// styles
const CardWrapper = styled(MainCard)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  color: theme.palette.primary.light,
  overflow: "hidden",
  position: "relative",
  "&:after": {
    content: '""',
    position: "absolute",
    width: 210,
    height: 210,
    background: `linear-gradient(210.04deg, ${colors.lightGold} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
    borderRadius: "50%",
    top: -30,
    right: -180,
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: 210,
    height: 210,
    background: `linear-gradient(140.9deg, ${colors.lightGold} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
    borderRadius: "50%",
    top: -160,
    right: -130,
  },
}));

export interface TotalCurrentPayOutDarkCardProps {
  isLoading: boolean;
  currentPayOut: string;
}

const TotalCurrentPayOutDarkCard = (props: TotalCurrentPayOutDarkCardProps) => {
  const theme = useTheme();

  const { isLoading, currentPayOut } = props;

  return (
    <>
      {isLoading ? (
        <SkeletonTotalCurrentPayOutDarkCard />
      ) : (
        <CardWrapper border={false} content={false}>
          <Box sx={{ p: 2 }}>
            <List sx={{ py: 0 }}>
              <ListItem alignItems="center" disableGutters sx={{ py: 0 }}>
                <ListItemAvatar>
                  <Avatar
                    variant="rounded"
                    sx={{
                      ...theme.typography.commonAvatar,
                      ...theme.typography.largeAvatar,
                      backgroundColor: colors.mainSecondary,
                      color: "#fff",
                    }}
                  >
                    <TableChartOutlinedIcon fontSize="inherit" />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  sx={{
                    py: 0,
                    mt: 0.45,
                    mb: 0.45,
                  }}
                  primary={
                    <Typography variant="h4" sx={{ color: "#fff" }}>
                      ${currentPayOut}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: colors.white,
                        mt: 0.25,
                        fontSize: "1.2rem",
                        fontWeight: 500,
                      }}
                    >
                      Total Current PayOut
                    </Typography>
                  }
                />
              </ListItem>
            </List>
          </Box>
        </CardWrapper>
      )}
    </>
  );
};

TotalCurrentPayOutDarkCard.propTypes = {
  isLoading: PropTypes.bool,
  currentPayOut: PropTypes.string,
};

export default TotalCurrentPayOutDarkCard;
